import React from 'react'
import { Row, Col, InputGroup } from 'reactstrap'
import { Upload } from '@progress/kendo-react-upload'
import { accentUtils, t, from} from '../services/HelperService'
import { uploadFileInChunks } from '../services/DataService'
import { AccentTokenCtrl } from './AccentTokenCtrl'

export class AccentUploadButton extends React.Component {

    constructor(props) {
        super(props);

        this.ctrl = React.createRef();
        this.attmtCtrl = React.createRef();


        this.attachmentRefresh = 1;
        this.attachments = this.props.defaultAttachments;

        // Files added programmatically (pasted images): they never enter the Kendo
        // Upload's internal list, so they ride alongside it and merge in saveFiles.
        this.pastedFiles = [];


        if (accentUtils.isNull(this.attachments)) {
            this.attachments = [];
        }

        this.maxFileSize = accentUtils.isNull(this.props.maxFileSize) ? 12000000 : this.props.maxFileSize;
        this.maxFileNameLength = 70;
        this.promis = null;

        this.onAttachmentsChanged = this.onAttachmentsChanged.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.onSuccess = this.onSuccess.bind(this);
        this.getFilesForUpload = this.getFilesForUpload.bind(this);
        this.hasInvalidFile = this.hasInvalidFile.bind(this);
        this.fileCount = this.fileCount.bind(this);
        this.saveFiles = this.saveFiles.bind(this);
        this.onRemoveURL = this.onRemoveURL.bind(this);
        this.setValue = this.setValue.bind(this);
        this.addFiles = this.addFiles.bind(this);
    }

    // Adds File objects programmatically (e.g. images pasted from the clipboard),
    // with the same validation and token behaviour as browsing for them.
    addFiles(files) {

        var me = this;

        if (!me.props.multiple) {
            me.attachments = [];
            me.pastedFiles = [];
        }

        (files || []).forEach(function (f) {

            if (from(me.attachments).any(function (a) { return a.value === f.name; })) return;

            var fname = f.name;
            var err = undefined;
            if (f.size > me.maxFileSize) {
                fname = t("application_strings.application.general.fileTooLarge", { file: fname });
                err = true;
            } else if (fname.length > me.maxFileNameLength) {
                fname = t("application_strings.application.general.fileNameTooLong", { file: fname, maxLength: me.maxFileNameLength });
                err = true;
            } else if (f.size == 0) {
                fname = t("application_strings.application.general.emptyFile", { file: fname });
                err = true;
            } else if (!accentUtils.isEmpty(me.props.allowedExtensions)) {

                const hasValidExt = from(me.props.allowedExtensions).any(ext => f.name.toLowerCase().endsWith(ext));

                if (!hasValidExt) {
                    fname = t("application_strings.application.general.fileTypeNotAllowed", { type: fname });
                    err = true;
                }
            }

            me.attachments.push({ text: fname, value: f.name, error: err });
            if (!err) {
                me.pastedFiles.push(f);
            }
        });

        if (!accentUtils.isNull(this.props.onChange)) {
            this.props.onChange(this.attachments);
        }

        this.attmtCtrl.current.setValue(this.attachments);

        this.forceUpdate();
    }

    setValue(attachments) {
        this.attachments = attachments || [];
        if (this.attmtCtrl.current) {
            this.attmtCtrl.current.setValue(this.attachments);
        }
        this.attachmentRefresh++;
        this.forceUpdate();
    }

    onRemoveURL(files, e) {
        return Promise.resolve(files[0]);
    }

    onAttachmentsChanged(e) {

        var me = this;

        if (!accentUtils.isNull(e.value)) {

            var removedFiles = from(this.attachments)
                .where(function (a) {
                    return !from(e.value)
                        .any(function (v) {
                            return v.value == a.value;
                        }) && !a.readOnly
                }).toArray();

            this.attachments = from(this.attachments)
                .where(function (a) {
                    return from(e.value)
                        .any(function (v) {
                            return v.value == a.value;
                        }) || a.readOnly
                }).toArray();



            me.attmtCtrl.current.setValue(this.attachments);

            // Removing a pasted file's token is its only removal path (it has no
            // Kendo file entry to remove).
            me.pastedFiles = from(me.pastedFiles)
                .where(f => !from(removedFiles).any(r => r.value === f.name))
                .toArray();

            if (removedFiles.length > 0) {



                var files = from(me.ctrl.current.files)
                    .where(f => from(removedFiles).any(r => f.name === r.value))
                    .toArray();


                if (files.length > 0) {

                    var uid = files[0].uid;

                    var args = {};
                    args[uid] = files;

                    me.ctrl.current.removeFiles(args);
                }
            }

            me.attachmentRefresh++;
            me.forceUpdate();

        }

        this.props.onChange(this.attachments);
    }


    fileCount() {
        return this.attachments.length;
    }


    uploadCount() {
        return this.ctrl.current.files.length;
    }

    hasInvalidFile() {

        return from(this.attachments).any(a => a.error);

    }

    onSelect(e) {

        var me = this;


        if (!me.props.multiple) {
            me.attachments = [];
        }

        if (!accentUtils.isNull(e.newState)) {

            var existing = from(me.attachments).toArray();

            e.newState.forEach(function (f) {

                if (!from(existing).any(function (a) { return a.value === f.name; })) {

                    var fname = f.name;
                    var err = undefined;
                    if (f.size > me.maxFileSize) {
                        fname = t("application_strings.application.general.fileTooLarge", { file: fname });
                        err = true;
                    } else if (fname.length > me.maxFileNameLength) {
                        fname = t("application_strings.application.general.fileNameTooLong", { file: fname, maxLength: me.maxFileNameLength });
                        err = true;
                    } else if (f.size == 0) {
                        fname = t("application_strings.application.general.emptyFile", { file: fname });
                        err = true;
                    } else if (!accentUtils.isEmpty(me.props.allowedExtensions)) {

                        const hasValidExt = from(me.props.allowedExtensions).any(ext => fname.toLowerCase().endsWith(ext));

                        if (!hasValidExt) {
                            fname = t("application_strings.application.general.fileTypeNotAllowed", { type: fname });
                            err = true;
                        }

                    }

                    me.attachments.push({ text: fname, value: f.name, error: err });
                }
            });

        }



        if (!accentUtils.isNull(this.props.onChange)) {
            this.props.onChange(this.attachments);
        }


        this.attmtCtrl.current.setValue(this.attachments);

        this.forceUpdate();


    }

    onRemove(e) {

    }

    onSuccess(e) {




    }




    getFilesForUpload() {

        var me = this;

        return new Promise(function (p) {

            me.promis = p;

            // With nothing in the Kendo list, uploadFiles never invokes saveFiles —
            // resolve the pasted files directly.
            if (me.ctrl.current.files.length === 0) {
                p({ files: [...me.pastedFiles] });
                return;
            }

            me.ctrl.current.uploadFiles({ dummyGroup: me.ctrl.current.files });

        });
    }


    async saveFiles(e, options, done) {

        const files = e.map(f => f.getRawFile());

        this.promis({ files: [...files, ...this.pastedFiles] });

    }



    render() {

        var restrictions = undefined;

        if (this.props.allowedExtensions || !accentUtils.isNull(this.props.maxFileSize)) {
            restrictions = {};
            if (this.props.allowedExtensions) {
                restrictions.allowedExtensions = this.props.allowedExtensions;
            }
            if (!accentUtils.isNull(this.props.maxFileSize)) {
                restrictions.maxFileSize = this.props.maxFileSize;
            }
        }

        return (
            <Row className="accentUploadBtn">
                <Col md={12} className="d-flex">
                    <div className="flex-fill">
                        <AccentTokenCtrl key={this.attachmentRefresh} noPopup noCustom ref={this.attmtCtrl} value={this.attachments} data={this.attachments} onChange={this.onAttachmentsChanged} label={this.props.label} noClearAll placeholder={this.props.placeholder} />
                    </div>
                    <div>
                        <Upload
                            ref={this.ctrl}
                            autoUpload={false}
                            defaultFiles={[]}
                            showActionButtons={false}
                            showFileList={false}
                            saveUrl={this.saveFiles}
                            saveField="files"
                            multiple={accentUtils.isNull(this.props.multiple) ? true : this.props.multiple}
                            restrictions={restrictions}
                            removeUrl={ this.onRemoveURL }
                            onAdd={this.onSelect}
                            onBeforeRemove={this.onRemove}
                            onStatusChange={this.onSuccess} />
                    </div>
                </Col>
            </Row>
        );
    }
}

// The upload button for large files: the same picker, but the files go to the server in
// pieces (DataService.uploadFileInChunks — every piece an ordinary small request, so no
// request-size limit stands in the way), with a progress bar under the picker while they go.
// The caller does not send the files itself: it hands upload(complete) a function that tells
// the endpoint wanting the files which uploads to take ({ UploadID, Batch, FileName, Count,
// Size } each) and resolves to an error text or null; upload resolves to that result. On
// success the picker is cleared (remounted); on failure the picked files stay for another go
// — the picker is read once per upload call, since Kendo will not hand out a file twice, and
// the retries happen on the pieces, not the pick.
// Same props as AccentUploadButton (tagName, multiple, allowedExtensions, label, onChange);
// maxFileSize defaults to 2 GB. Same ref methods: fileCount, hasInvalidFile, addFiles.
export class AccentChunkedUploadButton extends React.Component {

    constructor(props) {
        super(props);
        this.picker = React.createRef();
        this.state = { pickerKey: 0, sending: null };
        this.fileCount = this.fileCount.bind(this);
        this.hasInvalidFile = this.hasInvalidFile.bind(this);
        this.addFiles = this.addFiles.bind(this);
        this.upload = this.upload.bind(this);
    }

    fileCount() { return this.picker.current ? this.picker.current.fileCount() : 0; }

    hasInvalidFile() { return this.picker.current ? this.picker.current.hasInvalidFile() : false; }

    addFiles(files) { if (this.picker.current) this.picker.current.addFiles(files); }

    uploading() { return this.state.sending != null; }

    async upload(complete) {
        if (!this.picker.current || this.state.sending) return "An upload is already under way.";
        const { files } = await this.picker.current.getFilesForUpload();
        if (!files || files.length === 0) return "Choose a file first.";

        const total = files.reduce((sum, f) => sum + f.size, 0);
        let before = 0;
        const references = [];
        try {
            for (const file of files) {
                const done = before;
                this.setState({ sending: { name: file.name, sent: done, total, index: references.length + 1, count: files.length } });
                references.push(await uploadFileInChunks(file, {
                    onProgress: sent => this.setState({ sending: { name: file.name, sent: done + sent, total, index: references.length + 1, count: files.length } }),
                }));
                before += file.size;
            }
            this.setState({ sending: { name: null, sent: total, total, index: files.length, count: files.length } });
            const failure = await complete(references);
            if (!failure) {
                // The pick is spent (Kendo marks the files uploaded); a fresh picker for the next.
                this.setState(s => ({ pickerKey: s.pickerKey + 1 }));
                if (this.props.onChange) this.props.onChange([]);
            }
            return failure ?? null;
        } catch (e) {
            return e?.message ?? String(e);
        } finally {
            this.setState({ sending: null });
        }
    }

    render() {
        const { sending } = this.state;
        const mb = n => (n / (1024 * 1024)).toFixed(n >= 100 * 1024 * 1024 ? 0 : 1);
        const percent = sending && sending.total > 0 ? Math.round(100 * sending.sent / sending.total) : 0;
        return (
            <div>
                <AccentUploadButton
                    key={this.state.pickerKey}
                    ref={this.picker}
                    tagName={this.props.tagName}
                    multiple={this.props.multiple}
                    allowedExtensions={this.props.allowedExtensions}
                    maxFileSize={accentUtils.isNull(this.props.maxFileSize) ? 2 * 1024 * 1024 * 1024 : this.props.maxFileSize}
                    label={this.props.label}
                    placeholder={this.props.placeholder}
                    onChange={this.props.onChange}
                />
                {sending && (
                    <div className="mt-1" aria-live="polite">
                        <small className="text-muted">
                            {sending.name
                                ? `${sending.count > 1 ? `${sending.index} of ${sending.count}: ` : ""}${sending.name} — ${mb(sending.sent)} of ${mb(sending.total)} MB`
                                : "Attaching…"}
                        </small>
                        <div className="progress" style={{ height: 4 }}>
                            <div className="progress-bar" role="progressbar" style={{ width: `${percent}%` }} aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
